const rankingItems = [
  {
    rank: 1,
    title: '都市情缘：夏日邂逅',
    category: '国产剧情',
    heat: '本周播放 28.6万',
    img: 'https://readdy.ai/api/search-image?query=A%20romantic%20warm%20cinematic%20abstract%20design%20with%20soft%20coral%20pink%20and%20gold%20gradients%2C%20romantic%20drama%20theme%2C%20soft%20glowing%20light%20effects%2C%20dark%20rich%20background%2C%20summer%20romance%20vibe%2C%20no%20people%20no%20text%2C%20elegant%20film%20poster%20aesthetic&width=400&height=280&seq=rank-1-2026&orientation=landscape',
  },
  {
    rank: 2,
    title: '迷雾追踪：真相背后',
    category: '悬疑推理',
    heat: '本周播放 24.3万',
    img: 'https://readdy.ai/api/search-image?query=A%20mysterious%20dark%20cinematic%20abstract%20design%20with%20deep%20crimson%20and%20charcoal%20gradients%2C%20thriller%20mystery%20theme%2C%20dramatic%20shadow%20patterns%2C%20dark%20atmospheric%20background%2C%20suspense%20feel%2C%20no%20people%20no%20text%2C%20film%20noir%20aesthetic&width=400&height=280&seq=rank-2-2026&orientation=landscape',
  },
  {
    rank: 3,
    title: '欢乐一家人：暑假篇',
    category: '喜剧短片',
    heat: '本周播放 21.8万',
    img: 'https://readdy.ai/api/search-image?query=A%20warm%20bright%20cinematic%20abstract%20design%20with%20sunny%20golden%20and%20amber%20gradients%2C%20family%20comedy%20theme%2C%20cheerful%20uplifting%20vibe%2C%20dark%20background%20with%20warm%20accents%2C%20playful%20atmosphere%2C%20no%20people%20no%20text%2C%20lighthearted%20film%20aesthetic&width=400&height=280&seq=rank-3-2026&orientation=landscape',
  },
  {
    rank: 4,
    title: '都市夜话：第三季',
    category: '91传媒视频在线',
    heat: '本周播放 19.5万',
    img: 'https://readdy.ai/api/search-image?query=A%20sophisticated%20urban%20night%20cinematic%20abstract%20design%20with%20deep%20red%20and%20copper%20gradients%2C%20city%20nightlife%20theme%2C%20neon-inspired%20glow%2C%20dark%20rich%20background%2C%20modern%20drama%20vibe%2C%20no%20people%20no%20text%2C%20stylish%20editorial%20aesthetic&width=400&height=280&seq=rank-4-2026&orientation=landscape',
  },
  {
    rank: 5,
    title: '极限挑战：荒野求生',
    category: '动作冒险',
    heat: '本周播放 17.2万',
    img: 'https://readdy.ai/api/search-image?query=A%20rugged%20adventure%20cinematic%20abstract%20design%20with%20warm%20earth%20tones%20and%20golden%20amber%20gradients%2C%20wilderness%20survival%20theme%2C%20dramatic%20terrain-inspired%20textures%2C%20dark%20background%2C%20action%20adventure%20vibe%2C%20no%20people%20no%20text%2C%20epic%20cinematic%20aesthetic&width=400&height=280&seq=rank-5-2026&orientation=landscape',
  },
  {
    rank: 6,
    title: '青春纪念册：毕业季',
    category: '国产剧情',
    heat: '本周播放 15.8万',
    img: 'https://readdy.ai/api/search-image?query=A%20nostalgic%20youthful%20cinematic%20abstract%20design%20with%20warm%20pastel%20coral%20and%20soft%20gold%20gradients%2C%20graduation%20memories%20theme%2C%20dreamy%20soft%20focus%20effect%2C%20dark%20background%2C%20sentimental%20coming%20of%20age%20vibe%2C%20no%20people%20no%20text%2C%20warm%20emotional%20aesthetic&width=400&height=280&seq=rank-6-2026&orientation=landscape',
  },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-xl md:text-3xl font-heading font-bold text-foreground-950">
            热度榜单
          </h2>
          <p className="mt-3 text-sm text-foreground-600 max-w-[560px] mx-auto">
            本周91免费视频网站播放量最高的国产影片排行榜
          </p>
        </div>

        <div className="max-w-[900px] mx-auto flex flex-col gap-3">
          {rankingItems.map((item) => (
            <div
              key={item.rank}
              className="flex items-center gap-4 p-3 md:p-4 rounded-xl bg-background-50 border border-background-200/60 transition-all duration-200 hover:-translate-y-0.5 cursor-pointer"
            >
              <div className="flex-shrink-0 w-8 h-8 md:w-10 md:h-10 rounded-lg bg-background-100 flex items-center justify-center">
                <span
                  className={`text-sm md:text-base font-bold ${
                    item.rank <= 3 ? 'text-primary-500' : 'text-foreground-500'
                  }`}
                >
                  {item.rank}
                </span>
              </div>

              <div className="w-16 h-10 md:w-20 md:h-14 rounded-lg overflow-hidden flex-shrink-0">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover"
                />
              </div>

              <div className="flex-1 min-w-0">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 truncate">
                  {item.title}
                </h3>
                <div className="flex items-center gap-2 mt-0.5">
                  <span className="text-xs text-foreground-500 whitespace-nowrap">{item.category}</span>
                  <span className="text-xs text-foreground-400">·</span>
                  <span className="text-xs text-accent-600 font-medium whitespace-nowrap">{item.heat}</span>
                </div>
              </div>

              <div className="flex-shrink-0">
                <div className="w-8 h-8 rounded-full bg-primary-100 flex items-center justify-center cursor-pointer">
                  <i className="ri-play-fill text-primary-500 text-lg w-5 h-5 flex items-center justify-center"></i>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}